export const summaryText = [
  {
    chapterSummary:
      "Všichni ho známe, všichni ho používáme. Většina z nás ale neví, jak funguje. Řeč je samozřejmě o internetu.\n Internet není nic neviditelného. Jedná se o velké množství navzájem propojených zařízení, která spolu neustále komunikují. Zařízením, která něco chtějí, říkáme KLIENTI. Jiným zařízením, která nabízejí služby, říkáme SERVERY. Vše je propojeno pomocí CEST a CHYTRÝCH KŘIŽOVATEK. \n V následujících úkolech se na jednotlivá zařízení podíváme blíže.",
    prerequsities: ["Zatím nic."],
    learningOutcomes: [
      "Internet, není nic neviditelného.",
      "Kam se ukládá vše, co najdeme na internetu.",
      "Jak fungují zařízení jako server a chytrá křižovatka.",
      "Proč spolu servery a klienti potřebují komunikovat.",
      "Kudy putují všechna data.",
    ],
  },
  {
    chapterSummary:
      "V předchozí kapitole jsi viděl zařízení, která tvoří internet. V této kapitole se dozvíš více o datech, která si mezi sebou zařízení posílají.",
    prerequsities: [
      "Internet je tvořen klienty, servery, chytrými křižovatkami či cestami pro informace.",
      "Zařízení navzájem komunikují.",
    ],
    learningOutcomes: [
      "Co jsou pakety.",
      "Co obsahují pakety, aby byla data správně doručena.",
      "Jaký je rozdíl, mezi posláním videa a textové zprávy.",
    ],
  },
  {
    chapterSummary:
      "Už víš, jak vypadají přenášená data. V této kapitole se dozvíš, jak lze data přenášet.",
    prerequsities: [
      "Internet je tvořen klienty, servery, chytrými křižovatkami či cestami pro informace.",
      "Data jsou přenášená v paketech.",
    ],
    learningOutcomes: [
      "Jak jsou data přenášena.",
      "Různé typy bezdrátových připojení.",
      "Jak fungují kabely.",
      "Vlastnosti jednotlivých typů připojení.",
    ],
  },
  {
    chapterSummary:
      "Už znáš zařízení, ze kterých se skládá internet. Víme jak vypadají data a jak se posílají. V této kapitole se dozvíš více o cestování mezi odesílatelem a příjemcem.",
    prerequsities: [
      "Internet je tvořen klienty, servery, chytrými křižovatkami či cestami pro informace.",
      "Data jsou přenášená v paketech.",
    ],
    learningOutcomes: [
      "K čemu slouží IP adresa.",
      "Jaký je rozdíl mezi IPv4 a IPv6 adresami.",
      "Jaké vlastnosti by měla mít internetová síť.",
      "Jak se určí cesta paketů.",
    ],
  },
  {
    chapterSummary:
      "Už víš vše o tom, jak funguje internet. V této kapitole postavíš několik internetových sítí podle různých zadání. Musíš ale myslet na vše, co ses naučil.",
    prerequsities: [
      "Internet je tvořen klienty, servery, chytrými křižovatkami či cestami pro informace.",
      "Jaké vlastnosti by měla mít internetová síť.",
      "Jak jsou data přenášena.",
      "Různé typy bezdrátových připojení.",
      "Jak fungují kabely.",
      "Vlastnosti jednotlivých typů připojení.",
    ],
    learningOutcomes: ["Už vše umíš."],
  },
];
